import React from 'react';

import { useForm, FormProvider } from 'react-hook-form';
import { observer } from 'mobx-react';

import { PrizesFrom } from '../../../../../components/form-sections/PrizesFrom/PrizesFrom';
import { WidgetHeaderActions } from '../components/WidgetHeaderActions/WidgetHeaderActions';
import { ChallengePrizeFormValues } from '../../../../../interfaces/ChallengeFormValues';
import { loggedInUserDataStore } from '../../../../../../shared/stores/loggedInUserDataStore';
import {
  getPrizesFormValue,
  transformPrizesToFormValues,
} from './utils/getPrizesFormValue';
import { challengeService } from '../../../../../services/challengeService';
import { ChallengePrizeSection } from '../../../../../interfaces/SaveChallengeInfo';
import { useChallengeFormMode } from '../hook/useChallengeFormMode';
import { challengeProfileStore } from '../../../../../stores/challengeProfileStore';

type PrizesWidgetProps = {
  challengeId: number;
};

const PrizesWidget = observer(({ challengeId }: PrizesWidgetProps) => {
  const { statusFlags, invalidSectionFlags, getChallengeStatusDetails } =
    challengeProfileStore;
  const { isEntity } = loggedInUserDataStore;
  const { mode, setEdit, setView } = useChallengeFormMode('prizes');

  const formMethods = useForm<{ prizes: ChallengePrizeFormValues }>({
    defaultValues: async () => getPrizesFormValue(challengeId),
  });
  const { handleSubmit, reset } = formMethods;

  const handleSave = handleSubmit(async ({ prizes }) => {
    const updatedPrizes = await challengeService.updateChallengePrizes(
      challengeId,
      prizes as ChallengePrizeSection,
    );

    reset(transformPrizesToFormValues(updatedPrizes));
    getChallengeStatusDetails(challengeId);
    setView();
  });

  const handleCancel = () => {
    reset();
    setView();
  };

  const headerActions = (
    <WidgetHeaderActions
      mode={mode}
      isInvalid={invalidSectionFlags.PRIZES}
      onEdit={setEdit}
      onCancel={handleCancel}
      onSubmit={handleSave}
    />
  );

  const canEdit = isEntity && !statusFlags.FINISHED;

  return (
    <FormProvider {...formMethods}>
      <PrizesFrom mode={mode} headerActions={canEdit ? headerActions : undefined} />
    </FormProvider>
  );
});

export { PrizesWidget };
